import { inject, provide } from 'vue'
import type { GenericFolder } from '@deepcloud/api-deep-box'
import type { InjectionKey } from 'vue'

const KEY = Symbol('ContextGenericFolders') as InjectionKey<
  MaybeRefOrGetter<GenericFolder[]>
>

export function createContextGenericFolders(
  injectionData: MaybeRefOrGetter<GenericFolder[]>,
) {
  provide(KEY, injectionData)
}

export function useContextGenericFolders() {
  const injectionData = inject(KEY)
  if (!injectionData) {
    throw new Error(
      'Please call `createContextGenericFolders` on the appropriate parent component',
    )
  }

  return computed(() => toValue(injectionData))
}
